import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";

import { getNewsDetailsById, getNewsUpdate } from "../../api";
import { useSelector } from "react-redux";
import { NewsDetailsSchema } from "../../schema";
import ImageCropUpload from "../common/ImageCropUpload";

const EditNewsDetails = ({ id }) => {
  const { token } = useSelector((state) => state.profileReducer);
  const [news, setNews] = useState();
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [serviceData, setServiceData] = useState(null);
  const [previewImg, setPreviewImg] = useState(null);

  const initialValues = {
    image: news ? news?.image : "",
    title: news ? news?.title : "",
    content: news ? news?.content : "",
    link: news ? news?.link : "",
  };

  // const [specialityArr, setSpecialityArr] = useState([]);

  const editNewsHandler = async (values) => {
    const formData = new FormData();
    formData.append("image", values.image);
    formData.append("title", values.title);
    formData.append("content", values.content);
    formData.append("link", values.link);
    getNewsUpdate(id, formData, token)
      .then((res) => {
        setIsLoading(true);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const getNewsdata = () => {
    getNewsDetailsById(id, token)
      .then((res) => {
        // toast.current.show({severity: 'success', summary: `${res?.data?.message}`});
        setNews(res?.data?.data);
        setServiceData(res?.data?.data);
        setPreviewImg(res?.data?.data.image);
        if (res) {
          setServiceData(res?.data?.data);
        }
      })
      .catch((err) => {});
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    touched,
    handleBlur,
    setFieldValue,
    setFieldTouched,
  } = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: NewsDetailsSchema(),
    onSubmit: (values) => editNewsHandler(values),
  });

  // const handleOnChange = (e, setFieldValue, setFieldTouched, values) => {
  //   if (e.target.files.length) {
  //     setFieldValue(e.target.name, e?.target?.files[0]);
  //   } else {
  //     setFieldValue(e.target.name, values[e.target.name]);
  //   }
  // };

  useEffect(() => {
    async function getAllAPI() {
      await getNewsdata();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();
  return (
    <>
      <Toast ref={toast} />

      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="">
        <div className="news-details-cls-portion mt-4">
          <div className="event-details-all-starting-part">
            <div className="userprofile-pics">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    <path
                      d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                      fill="black"
                    />
                  </svg>
                  <h6 className="mb-0">Back to news details</h6>
                </div>
              </div>
            </div>

            <div className="main-profile-all-cls-start mt-4">
              <div className="details-all-name upload-user-profile-cls">
                <div className="row">
                  <div className="col-lg-4 position-relative">
                    <label className="my-2">
                        Upload image:-{" "}
                        <span className="required">
                          {" "}
                          Crop will be saved as 300w X 280h
                        </span>
                      </label>
                    <div className="left-side-img">
                      {/* <img
                        className="set-img-news-auto"
                        src={
                          serviceData?.image
                            ? serviceData?.image
                            : require("../../assets/defaultnews.png")
                        }
                        alt="land"
                      /> */}
                      {/* <img
                        className="set-img-news-auto"
                        src={
                          serviceData?.image
                            ? serviceData?.image
                            : require("../../assets/defaultnews.png")
                        }
                        alt="Preview1"
                      /> */}
                      {previewImg && serviceData && (
                        <div className="text-centersall">
                          <img
                            src={
                              previewImg
                                ? previewImg
                                : require("../../assets/defaultImg.png")
                            }
                            alt="Preview1"
                          />
                        </div>
                      )}
                    </div>

                    <div className="mt-4">
                      <ImageCropUpload
                        name="image"
                        onBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        onCroppedFile={(file) =>
                          setPreviewImg(URL.createObjectURL(file))
                        }
                        error={errors.image}
                        touched={touched.image}
                      />
                      <span className="upload-all-btns-cls-add"></span>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput2"
                      placeholder="Enter Title here"
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.title && touched.title ? (
                      <p className="form-error">{errors.title}</p>
                    ) : null}
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-8">
                    <label className="my-2">Link</label>
                    <input
                      type="link"
                      className="form-control"
                      id="exampleFormControlInput2"
                      name="link"
                      placeholder="Write here"
                      value={values.link}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.link && touched.link ? (
                      <p className="form-error">{errors.link}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-8">
                    <label className="my-2">Content</label>
                    <textarea
                      className="form-control"
                      placeholder="Write here"
                      name="content"
                      id="floatingTextarea"
                      value={values.content}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {errors.content && touched.content ? (
                      <p className="form-error">{errors.content}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-8">
                    <div className="right-sidebtn-add text-end">
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary outline-btn-cls me-3"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary filled-btn-cls"
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default EditNewsDetails;
